export class CreatePermissionDto{
    permissions: string[];
}
